import { Trans } from "@lingui/react/macro";
import { ChatMarkdown } from "@rakazo/chat-ui/web";
import { groupPostCollapses, groupPostPreview, splitOwnerRequest } from "@rakazo/core";
import { useState } from "react";

/** Bot text, with a group post collapsed and an owner ask lifted into a callout. */
export function BotMessageBody({
  text,
  streaming = false,
  group = false,
  quoteMessageId,
  className,
}: {
  text: string;
  streaming?: boolean;
  group?: boolean;
  quoteMessageId?: string;
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  const parsed = streaming ? { body: text } : splitOwnerRequest(text);
  const collapse = group && !streaming && groupPostCollapses(parsed.body);
  const shown = collapse && !open ? groupPostPreview(parsed.body) : parsed.body;
  return (
    <div data-quote-message-id={quoteMessageId} className={className}>
      {shown ? <ChatMarkdown streaming={streaming}>{shown}</ChatMarkdown> : null}
      {collapse ? (
        <button
          type="button"
          data-testid="group-post-toggle"
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
          className="mt-1 text-[13px] font-medium text-muted-foreground hover:text-foreground"
        >
          {open ? <Trans>Show less</Trans> : <Trans>Show more</Trans>}
        </button>
      ) : null}
      {parsed.ask ? (
        <div
          data-testid="needs-you-callout"
          className="mt-2.5 rounded-xl border border-warning/40 bg-warning/10 px-3 py-2"
        >
          <div className="text-[12px] font-semibold tracking-tight text-warning">
            <Trans>Needs you</Trans>
          </div>
          <p className="mt-0.5 text-[14.5px] leading-snug text-foreground">{parsed.ask}</p>
        </div>
      ) : null}
    </div>
  );
}
